import React from 'react';

type TodaysPickComponentProps = {
  children: JSX.Element;
};

function TodaysPick({ children }: TodaysPickComponentProps) {
  return <div className="todaysPick__route">{children}</div>;
}

export default TodaysPick;
